import { serverFetch } from "@core/server";

const compact = (values) =>
  Object.fromEntries(
    Object.entries(values || {}).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );

export const fetchWarehouseDocuments = (query = {}) =>
  serverFetch("warehouse/documents", { queryParams: compact(query) });

export const fetchWarehouseDocument = (id) => serverFetch(`warehouse/documents/${id}`);

export const fetchWarehouseLookups = () => serverFetch("warehouse/lookups");

export const fetchWarehouseProducts = (query = {}) =>
  serverFetch("warehouse/products", { queryParams: compact(query) });

export const createWarehouseDocument = (bodyData) =>
  serverFetch("warehouse/documents", { method: "POST", bodyData });

export const updateWarehouseDocument = (id, bodyData) =>
  serverFetch(`warehouse/documents/${id}`, { method: "PUT", bodyData });

export const deleteWarehouseDocument = (id) =>
  serverFetch(`warehouse/documents/${id}`, { method: "DELETE" });

export const postWarehouseDocument = (id) =>
  serverFetch(`warehouse/documents/${id}/post`, { method: "POST" });

export const unpostWarehouseDocument = (id) =>
  serverFetch(`warehouse/documents/${id}/unpost`, { method: "POST" });

export const fetchWarehouseRestCheck = (id) => serverFetch(`warehouse/documents/${id}/rest-check`);

export const fillWarehouseInventory = (id) =>
  serverFetch(`warehouse/documents/${id}/fill-inventory`, { method: "POST" });

export const fetchWarehouseRegister = (query = {}) =>
  serverFetch("warehouse/register", { queryParams: compact(query) });

export const fetchWarehouseMovements = (query = {}) =>
  serverFetch("warehouse/movements", { queryParams: compact(query) });

export const fetchWarehouseProductCard = (query = {}) =>
  serverFetch("warehouse/product-card", { queryParams: compact(query) });
